(() => {
  const key = '__oneLuxuryOrganicSchemaSync';
  if (window[key]) return;
  window[key] = { subscribed: false };

  const matchingSchemas = (root, sectionId, productId) =>
    [...root.querySelectorAll('script[data-organic-product-schema]')].filter(
      (node) => node.dataset.sectionId === sectionId && node.dataset.productId === productId
    );

  const sync = ({ data } = {}) => {
    try {
      const { variant, sectionId, html } = data || {};
      const variantId = String(variant?.id || '');
      if (!/^\d+$/.test(variantId) || !sectionId || !html?.querySelectorAll) return;

      const products = [...document.querySelectorAll('product-info[data-section-type="product-page"]')].filter(
        (node) => (node.dataset.originalSection || node.dataset.sectionId) === sectionId
      );
      if (products.length !== 1) return;
      const product = products[0];
      if (String(product.currentVariant?.id || '') !== variantId) return;

      const productId = product.dataset.productId;
      if (!/^\d+$/.test(productId || '')) return;
      const destinations = matchingSchemas(document, sectionId, productId);
      const sources = matchingSchemas(html, sectionId, productId);
      if (destinations.length !== 1 || sources.length !== 1) return;
      const destination = destinations[0];
      const source = sources[0];
      if (source.dataset.variantId !== variantId) return;

      const previous = JSON.parse(destination.textContent);
      const next = JSON.parse(source.textContent);
      if (
        previous['@type'] !== 'Product' || next['@type'] !== 'Product' ||
        !previous['@id'] || previous['@id'] !== next['@id'] ||
        !previous.url || previous.url !== next.url ||
        (variant.sku && next.sku !== variant.sku)
      ) return;

      destination.textContent = source.textContent;
      destination.dataset.variantId = variantId;
    } catch (_) {
      return;
    }
  };

  const subscribe = () => {
    if (window[key].subscribed) return;
    const event = window.MinimogTheme?.pubSubEvents?.variantChange;
    if (!event || typeof window.MinimogEvents?.subscribe !== 'function') return;
    window.MinimogEvents.subscribe(event, sync);
    window[key].subscribed = true;
  };

  subscribe();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribe, { once: true });
})();
